import css from 'styled-jsx/css';
import { colors, icons } from '../../../config/styles';
import { svgToDataUri } from '../../../utils/styles/svgMixins';

const PopoverStyles = css`
  .alert-container {
    display: flex;
    padding: 1rem;
    align-items: center;
    i {
      margin-right: 9px;
      width: 17px;
      height: 17px;
      &.csicon-info-outline {
        background-image: url('${svgToDataUri(icons.infoIconOutline)}');
        color: #00335d;
        -webkit-text-stroke: 1px currentColor;
        -webkit-text-fill-color: transparent;
        width: 24px;
        height: 24px;
      }
    }
    &.success {
      background-color: ${colors.green.shade23};
      color: ${colors.green.shade22};
    }
    &.info {
      border-radius: 8px;
      background: #e6f1fa;
      box-shadow: 0px 2px 2px rgba(29, 29, 29, 0.1);
    }
  }

  .warning {
    background-color: ${colors.yellow.shade5};
    i {
      color: #f7b500;
    }
  }
`;

export default PopoverStyles;
